/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type Person from '@linc-technologies/linced-common/models/person';
import type School from '@linc-technologies/linced-common/models/school';
import type Pdf from '@linc-technologies/linced-common/models/snapshots/pdf';
import type MediaService from '@linc-technologies/linced-common/services/media';
import moment from 'moment/moment';

// Proto: snapshots.Snapshot.
export default class Snapshot extends Model {
  declare [Type]: 'snapshots/snapshot';

  // Services
  @service
  declare media: MediaService;

  // Attributes
  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('number')
  declare createTime: number | undefined;

  @computed('createTime')
  get createDate() {
    return this.createTime
      ? moment.unix(this.createTime).format('DD/MM/YYYY HH:mm')
      : '';
  }

  @belongsTo('person', { async: true, inverse: null })
  declare generatedById: AsyncBelongsTo<Person>;

  @alias('generatedById')
  declare generatedBy: AsyncBelongsTo<Person>;

  @belongsTo('person', { async: true, inverse: null })
  declare learnerId: AsyncBelongsTo<Person>;

  @alias('learnerId')
  declare learner: AsyncBelongsTo<Person>;

  @attr()
  declare metadata: unknown;

  @fragmentArray('snapshots/pdf')
  declare pdfs: FragmentArray<Pdf>;
}
